import {
  get,
  post,
  put,
  del,
} from './http';

export function addComment(data, context) {
  return post(context, 'comment', data);
}

export function editComment(id, data, context) {
  return put(context, `comment/${id}`, data);
}

export function deleteComment(id, context) {
  return del(context, `comment/${id}`);
}

export function commentsUser(data, context) {
  return get(context, 'user/comments', data);
}

export function commentPublic(id, context) {
  return get(context, `user/comment/${id}`);
}
